import type { ICellRendererParams } from 'ag-grid-community';

import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { useCrmUrl } from '@/utils/crm-url';

import { ScheduledDonorType } from '../types';

export const ScheduledDonorName = ({
  value,
  data,
}: ICellRendererParams<ScheduledDonorType>) => {
  const isNucleusLinkEnabled = useFeatureFlag('Fert_Nucleus_Hyperlinks');
  const baseUrl = useCrmUrl();
  if (isNucleusLinkEnabled) {
    if (!data?.donorScheduleID) {
      return value;
    }

    return (
      <a
        href={`/donor-scheduling?edit=true&id=${data.donorScheduleID}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {value}
      </a>
    );
  }

  if (!baseUrl) {
    return value;
  }

  const url = new URL('main.aspx', baseUrl);
  url.searchParams.set('etc', '10081');
  url.searchParams.set(
    'extraqs',
    'formid=cf94e021-761e-4198-a8e4-61683662691d',
  );
  url.searchParams.set('id', `{${data?.donorScheduleID}}`);
  url.searchParams.set('pagetype', 'entityrecord');

  return (
    <a href={url.toString()} target="_blank" rel="noopener noreferrer">
      {value}
    </a>
  );
};
